<template>
  <form method="post" :action="formRoute" id="profile-img-form" enctype="multipart/form-data">
    <div class="profile-image-upload">
      <div class="mb-2">
        <div class="inline-block relative">
          <img class="profile-image" :src="image" alt="">
        </div>
      </div>
      <div class="d-flex img-upload-actions">
        <input type="hidden" name="remove_old_image" :value="removeOldImage ? '1' : '0'">
        <input type="file" style="display: none;" name="profile_image" @change="imageFieldChange" ref="imageUpload"
               accept="image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png">
        <input name="_token" :value="csrf" type="hidden">
        <button class="no-style-button" type="button" @click="pickImage()">Välj ny bild</button>
      </div>

      <div class="img-upload-msg mb-3"><small>Bilden du väljer måste vara mindre än 3MB stor.</small></div>
      <div class="img-upload-error mb-3" v-if="showFileSizeError">Bilden du har valt är större än 3MB. Välj en annan
        bild eller förminska bilden och försök igen.
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ['profileImage', 'originalImage', 'defaultImage', 'formRoute', 'csrf'],
  data() {
    return {
      image: this.profileImage,
      removeOldImage: false,
      showFileSizeError: false
    }
  },
  methods: {
    pickImage() {
      jQuery(this.$refs.imageUpload).trigger("click");
    },
    imageFieldChange() {
      this.showFileSizeError = false;
      var reader = new FileReader();

      var file = this.$refs.imageUpload.files[0];

      reader.onloadend = () => {
        this.image = reader.result;
      }
      if (file) {
        if (file.size > 3 * 1024 * 1024) {
          this.showFileSizeError = true;
          return false;
        }
        reader.readAsDataURL(file); //reads the data as a URL
        this.removeOldImage = true;
      } else {
        this.image = "";
      }
      $('#profile-img-form').submit();
    },
},
}
</script>
<style scoped>
.profile-image {
  max-width: 85px !important;
  max-height: 85px !important;
  margin-top: 1.5rem !important;
}

button {
  white-space: nowrap !important;
}

.img-upload-actions {
  margin-top: 70px;
}

.img-upload-error {
  white-space: nowrap !important;
}

.img-upload-msg {
  white-space: nowrap !important;
}
</style>